export default {
  // Common
  common: {
    loading: 'Cargando...',
    selectYourLanguage: 'Selecciona tu idioma',
    error: 'Error',
    save: 'Guardar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    back: 'Atrás',
    next: 'Siguiente',
    download: 'Descargar',
    reset: 'Limpiar',
    delete: 'Eliminar',
    edit: 'Editar',
    yes: 'Sí',
    no: 'No',
    search: 'Buscar',
    filter: 'Filtrar',
    menu: 'Menú',
    saved: 'Guardado',
    continued: 'continuación',
    currency: {
      USD: "Dólares Estadounidenses (USD)",
      MXN: "Pesos Mexicanos (MXN)",
      EUR: "Euros (EUR)",
      GBP: "Libras Esterlinas (GBP)",
      JPY: "Yenes Japoneses (JPY)",
      CNY: "Yuan Chino (CNY)",
      RUB: "Rublos Rusos (RUB)"
    },
    copyright: 'Todos los derechos reservados.',
    per: 'por',
    liter: 'Litro',
    gallon: 'Galón',
    unit: 'Unidad',
    and: 'y',
    close: 'Cerrar',
    continue: 'Continuar',
    globalCountryOption: 'Global (todos los países)',
    hours: 'horas',
    minutes: 'minutos',
    currency_preference: 'Moneda Preferida'
  },
  
  // Auth forms
  auth: {
    login: 'Iniciar Sesión',
    register: 'Crear Cuenta',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    fullName: 'Nombre Completo',
    company: 'Empresa (Opcional)',
    city: 'Ciudad',
    postalCode: 'Código Postal',
    phoneNumber: 'Número de Teléfono',
    phoneNoSpaces: 'Sin guiones ni espacios',
    forgotPassword: '¿Olvidaste tu contraseña?',
    passwordRequirements: {
      title: 'Tu contraseña debe tener:',
      length: 'Al menos 8 caracteres',
      uppercase: 'Al menos una letra mayúscula',
      number: 'Al menos un número',
      special: 'Carácter especial (recomendado)'
    },
    agreedToTerms: 'He leído y acepto los',
    termsAndConditions: 'Términos y Condiciones',
    privacyPolicy: 'Aviso de Privacidad',
    rememberMe: 'Recordar mis datos en este dispositivo',
    noAccount: '¿No tienes cuenta? Regístrate',
    haveAccount: '¿Ya tienes cuenta? Inicia sesión',
    resetPassword: 'Restablecer Contraseña',
    resetPasswordInstructions: 'Ingresa tu dirección de correo electrónico registrada y te enviaremos un enlace para restablecer tu contraseña.',
    sendResetLink: 'Enviar Enlace de Recuperación',
    resetPasswordSuccess: 'Se ha enviado un enlace de recuperación a tu correo electrónico',
    emailConfirmation: {
      title: '¡Registro Exitoso!',
      subtitle: 'Confirma tu dirección de email para poder iniciar sesión',
      instructionsTitle: 'Instrucciones:',
      step1Title: 'Revisa tu email:',
      step1Description: 'Hemos enviado un enlace de confirmación a',
      step2Title: 'Haz clic en el enlace:',
      step2Description: 'Abre el email y haz clic en el enlace de confirmación.',
      step3Title: 'Inicia sesión:',
      step3Description: 'Una vez confirmado, regresa aquí para iniciar sesión y recibir tus 5 créditos gratuitos.',
      freeCreditsMessage: '5 créditos gratuitos te esperan después de confirmar tu email',
      backToLogin: 'Volver al Inicio de Sesión',
      noEmailReceived: '¿No recibiste el email? Revisa tu carpeta de spam o correo no deseado.'
    },
    benefits: {
      title: '¿Por qué usar Cotizatrin?',
      accurate: {
        title: 'Cotizaciones Precisas',
        description: 'Obtén cotizaciones de transporte exactas basadas en datos en tiempo real e información de peajes'
      },
      time: {
        title: 'Ahorra Tiempo',
        description: 'Genera cotizaciones profesionales en minutos en lugar de horas de cálculos manuales'
      },
      professional: {
        title: 'PDFs Profesionales',
        description: 'Descarga PDFs detallados y personalizados listos para compartir con tus clientes'
      },
      tollData: {
        title: 'Datos de Peajes Actualizados',
        description: 'Accede a los costos de peajes actuales en todas las rutas principales de México'
      },
      pesos: 'pesos',
      globalCountryOption: 'Global (todos los países)',
      multiCurrency: {
        title: 'Múltiples Monedas',
        description: 'Visualiza y exporta cotizaciones en diferentes monedas para clientes internacionales'
      },
      security: {
        title: 'Seguridad Especializada',
        description: 'Recibe recomendaciones de seguridad personalizadas según el tipo de carga'
      },
      quotationsGenerated: 'Cotizaciones generadas'
    }
  },
  
  // Dashboard
  dashboard: {
    welcome: 'Bienvenido,',
    newQuotation: 'Nueva Cotización',
    quotationHistory: 'Historial de Cotizaciones',
    adminPanel: 'Panel de Administrador',
    advancedMode: 'Avanzado',
    formGuide: 'Guía del Formulario',
    additionalInfo: 'Información Adicional',
    additionalResources: 'Recursos Adicionales',
    logout: 'Cerrar Sesión',
    completeForms: 'Completa el formulario para obtener una cotización detallada.'
  },
  
  // Quotation Form
  quotationForm: {
    title: 'Cotización de Transporte',
    subtitle: 'Completa el formulario para generar una cotización detallada',
    vehicleConfig: 'Configuración del Vehículo',
    vehicleType: 'Tipo de Vehículo',
    trailerType: 'Tipo de Remolque',
    noTrailer: 'Sin Remolque',
    cargoType: 'Tipo de Mercancía',
    selectCargoType: 'Selecciona el tipo de mercancía',
    riskFactor: 'Factor de riesgo para esta mercancía',
    costParams: 'Parámetros de Costos',
    fuelPrice: 'Precio del Combustible',
    profitMargin: 'Margen de Utilidad',
    taxVat: 'IVA/Impuesto',
    taxDiscountHelp: 'Selecciona el porcentaje de impuesto aplicable para obtener el costo ajustado de las casetas sin IVA.',
    taxDiscountNote: 'Este porcentaje se aplica como descuento al costo de casetas para calcular el precio sin IVA.',
    transportRoute: 'Ruta de Transporte',
    transportRouteDescription: 'Define el origen, destino y cualquier parada intermedia para tu transporte',
    origin: 'Origen',
    destination: 'Destino',
    enterOrigin: 'Ingresa la ubicación de origen',
    enterDestination: 'Ingresa la ubicación de destino',
    routeInfo: 'Información de la Ruta:',
    distance: 'Distancia:',
    estTime: 'Tiempo estimado:',
    totalDistance: 'Distancia total (ida y vuelta):',
    locationsSelected: 'Ubicaciones seleccionadas:',
    calculateRoute: 'Calcular ruta ahora',
    resetForm: 'Limpiar formulario',
    generateQuotation: 'Generar Cotización',
    calculating: 'Calculando...',
    loadStatusHelp: 'Selecciona si el vehículo va cargado o vacío para este segmento. Los vehículos vacíos consumen menos combustible.',
    defaultValue: 'Valor predeterminado: 1.5 USD',
    advancedMode: 'Modo Avanzado',
    advancedModeDescription: 'Muestra opciones de configuración adicionales como tipo de carga y parámetros de costos',
    enableAdditionalDestinations: 'Habilitar Destinos Adicionales',
    additionalDestinationsDescription: 'Permite agregar hasta 5 destinos intermedios para rutas complejas',
    route: {
      oneWay: 'solo ida',
      roundTrip: 'ida y vuelta'
    },
    
    // Tooltips for form sections
    tooltips: {
      vehicleConfig: "Selecciona el tipo de vehículo y remolque según las necesidades de tu carga. Esto afectará los costos de transporte, consumo de combustible y capacidades de carga.",
      costParams: "Configura parámetros de costos para personalizar tu cotización. Incluye precio de combustible, margen de utilidad y ajustes de impuestos.",
      cargoType: "El tipo de mercancía influye en el factor de riesgo y recomendaciones de seguridad para el transporte. Mercancía peligrosa o valiosa tiene mayor factor de riesgo.",
      fuelPrice: "Precio actual del combustible por litro o galón. Este valor afecta directamente el cálculo del costo de transporte.",
      profitMargin: "Porcentaje de utilidad aplicado sobre el costo base. Determina la rentabilidad de la operación.",
      taxVat: "Porcentaje de IVA aplicado a los costos de casetas. Se descuenta para obtener valor sin impuesto.",
      currency: "Selecciona la moneda en la que quieres ver los resultados. Todos los costos se convertirán automáticamente a la moneda seleccionada.",
      route: "Configura la ruta de transporte incluyendo origen, destino y cualquier parada intermedia. La precisión de las ubicaciones afecta la precisión del cálculo.",
      tollDetails: "Muestra información detallada sobre las casetas de la ruta seleccionada, incluyendo costos y métodos de pago disponibles."
    },
    
    // Waypoint translations
    waypoints: {
      stops: 'Paradas Intermedias',
      addStops: 'Agregar paradas intermedias',
      noStops: 'Sin paradas intermedias. Agrega hasta 5 paradas.',
      stop: 'Parada',
      intermediateStop: 'Parada intermedia',
      addStop: 'Agregar parada',
      removeStop: 'Eliminar parada',
      loaded: 'Cargado',
      empty: 'Vacío',
      // Nuevas traducciones para waypoints como destinos siguientes
      nextDestinations: 'Destinos Adicionales',
      nextDestination: 'Destino',
      addDestination: 'Agregar destino',
      maxReached: 'Máximo de {{max}} destinos adicionales alcanzado.',
      noDestinations: 'Sin destinos adicionales. Puedes agregar hasta 5 destinos en secuencia.',
      routeDescription: 'La ruta se calculará en este orden exacto: Origen → Destino Principal → Destinos Adicionales.',
      firstSegmentLoad: 'Estado de Carga del Primer Segmento',
      loadStatusHelp: 'Selecciona si el vehículo va cargado o vacío para este segmento'
    },
    
    // Segment information
    segments: {
      title: 'Información de Segmentos',
      segment: 'Segmento',
      totalDistance: 'Distancia total:',
      estimatedTime: 'Tiempo estimado:',
      multiSegmentRoute: 'Información de Ruta Multi-Segmento'
    },
    
    // Results section
    result: {
      title: 'Resultado de la Cotización',
      calculated: 'Calculado',
      tripDetails: 'Detalles del Viaje',
      configuration: 'Configuración Seleccionada',
      origin: 'Origen:',
      destination: 'Destino:',
      oneWayDistance: 'Distancia (solo ida):',
      roundtripDistance: 'Distancia total (ida y vuelta):',
      vehicle: 'Vehículo:',
      merchandise: 'Mercancía:',
      fuel: 'Combustible:',
      profit: 'Margen de utilidad:',
      riskFactor: 'Factor de riesgo:',
      taxDiscount: 'Descuento de impuesto:',
      currency: 'Moneda:',
      totalCost: 'Costo Total',
      baseCost: 'Costo Base:',
      plusProfit: '+ Utilidad',
      plusRisk: '+ Factor de Riesgo:',
      costBreakdown: 'Desglose de Costos',
      saveQuotation: 'Guardar Cotización',
      downloadPDF: 'Descargar PDF',
      downloadMapImage: 'Descargar Imagen del Mapa',
      with: 'con'
    },
    
    // Cost breakdown items
    costItems: {
      depreciation: 'Depreciación',
      insurance: 'Seguros',
      gps: 'GPS',
      registration: 'Emplacado',
      mechanicalVerification: 'Verificación Mecánica',
      emissionVerification: 'Verificación de Emisiones',
      driverSalary: 'Salario del Conductor',
      driverBenefits: 'Prestaciones del Conductor',
      maintenance: 'Mantenimiento',
      tireCost: 'Llantas',
      fuelCost: 'Combustible',
      tollCost: 'Casetas',
      profit: 'Utilidad',
      riskFactor: 'Factor de Riesgo (Mercancía)',
      total: 'Total',
      tollDetailsSectionTitle: 'Detalles de Casetas',
      noVat: 'Sin IVA',
      reducedRate: 'Tasa reducida',
      standardVat: 'IVA estándar',
      specialRate: 'Tasa especial',
      highRate: 'Tasa alta',
      veryHighRate: 'Tasa muy alta',
      extremeRate: 'Tasa extrema',
      maximumRate: 'Tasa máxima',
      exceptionalRate: 'Tasa excepcional',
      limitRate: 'Tasa límite'
    },
    
    // Errors and warnings
    errors: {
      missingInfo: 'Falta información requerida',
      calculationFailed: 'Error al calcular cotización',
      saveFailed: 'Error al guardar cotización',
      routeNotFound: 'No se encontró ruta entre estos puntos',
      routeCalculationFailed: 'Error al calcular ruta',
      tollCalculationFailed: 'Error al calcular costos de casetas',
      unknownError: 'Error desconocido',
      tollApiError: 'No se pudieron obtener datos de casetas',
      generateToSee: 'Genera una cotización para ver detalles de casetas',
      costsMayNotIncludeTolls: 'El costo total puede no incluir los cargos de casetas',
      emailRequired: 'El correo electrónico es requerido',
      emailNotFound: 'No existe una cuenta con este correo',
      resetPasswordFailed: 'Ocurrió un error al enviar el correo de restablecimiento',
      passwordRequirements: 'La contraseña debe tener al menos 8 caracteres, una letra mayúscula y un número',
      passwordsMismatch: 'Las contraseñas no coinciden',
      nameRequired: 'El nombre es requerido',
      cityRequired: 'La ciudad es requerida',
      postalCodeRequired: 'El código postal es requerido',
      phoneRequired: 'El número telefónico es requerido',
      authError: 'Ocurrió un error durante la autenticación',
      mapImageMissing: 'No hay imagen del mapa disponible para descargar',
      downloadFailed: 'Error al descargar imagen'
    },
    helpers: {
      missingVehicleType: 'Tipo de vehículo',
      missingOrigin: 'Ubicación de origen',
      missingDestination: 'Ubicación de destino',
      routeNotCalculated: 'Cálculo de ruta',
      missingAdditionalDestinationLocation: 'Ubicaciones de destinos adicionales',
      missingInfoDetails: 'Falta: {{details}}',
      clickToSeeRequirements: 'Pasa el mouse para ver los requisitos faltantes'
    }
  },
  
  // Toll Details
  tollDetails: {
    title: 'Casetas',
    updated: 'Actualizado:',
    totalTollCost: 'Costo Total de Casetas',
    lastUpdated: 'Última actualización',
    showTolls: 'Mostrar casetas',
    totalTollbooths: 'Total de Casetas',
    totalDistance: 'Distancia Total',
    totalCost: 'Costo Total',
    vehicleInfo: 'Los costos de casetas se calculan según el tipo de vehículo, número de ejes y dimensiones.',
    tollTable: {
      tollbooth: 'Caseta',
      operator: 'Operador',
      distance: 'Distancia',
      cost: 'Costo',
      paymentMethods: 'Métodos de Pago'
    },
    vatTitle: 'IVA/Impuesto',
    originalCost: 'Costo Original:',
    vatDiscount: 'IVA/Impuesto',
    finalCost: 'Costo Final:',
    tollNote: 'Los costos de casetas se basan en información real y pueden variar por temporada.',
    onewayNote: 'Nota: Los costos mostrados incluyen solo ida.'
  },
  
  // Routes display
  alternateRoutes: 'Rutas Alternativas',
  route: 'Ruta',
  
  // Quotation History
  history: {
    title: 'Historial de Cotizaciones',
    subtitle: 'Tus cotizaciones recientes',
    noQuotations: 'Sin cotizaciones',
    noQuotationsMsg: 'Aún no has hecho ninguna cotización. Crea una nueva para verla aquí.',
    confirmDelete: 'Confirmar',
    deleteSuccess: 'Cotización eliminada exitosamente.',
    deleteError: 'Error al eliminar cotización. Por favor intenta de nuevo.',
    quotationWith: 'con',
    profitMargin: 'Con {{margin}}% de utilidad',
    profitMarginZero: 'Sin margen de utilidad (0%)',
    routeDetails: 'Detalles de la Ruta',
    origin: 'Origen:',
    destination: 'Destino:',
    oneWayDistance: 'Distancia (solo ida):',
    date: 'Fecha:',
    multiSegmentRoute: 'Ruta multi-segmento:',
    segments: 'segmentos',
    totalCost: 'Costo Total',
    baseCost: 'Costo Base:',
    profit: 'Utilidad',
    riskFactor: 'Factor de riesgo',
    total: 'Total:',
    routeMap: 'Mapa de la Ruta',
    download: 'Descargar',
    noMapImage: 'No hay imagen del mapa disponible',
    configuration: 'Configuración',
    vehicle: 'Vehículo:',
    trailer: 'Remolque:',
    noTrailer: 'Sin remolque',
    cargo: 'Carga:',
    risk: 'Riesgo:',
    downloadMap: 'Descargar mapa',
    transactionTypes: {
      used: 'Usado',
      purchased: 'Comprado',
      initial: 'Inicial',
      added: 'Añadido'
    }
  },
  
  // Payment methods
  paymentMethods: {
    cash: 'Efectivo',
    card: 'Tarjeta',
    tag: 'TAG',
    iave: 'IAVE'
  },
  
  // Token system
  tokens: {
    available: 'créditos de cotización disponibles',
    token: 'crédito de cotización disponible',
    noTokens: 'No tienes suficientes créditos para hacer cotizaciones.',
    lowTokens: 'Te quedan pocos créditos. Considera comprar más.',
    unlimited: 'Créditos Ilimitados',
    buy: 'Comprar Créditos',
    history: 'Historial',
    adminAccess: 'Acceso Administrativo (Créditos Ilimitados)',
    loading: 'Cargando créditos...',
    noAvailable: 'No hay créditos disponibles',
    transaction: {
      quotationGenerated: 'Cotización generada'
    },
    confirmationModal: {
      title: 'Confirmar generación',
      insufficientTitle: 'Créditos insuficientes',
      useToken: 'Esta acción usará 1 crédito de cotización de tu cuenta. Actualmente tienes',
      pdfsIncluded: 'Después de generar la cotización, podrás descargarla como PDF o guardarla sin costo adicional.',
      noTokens: 'No tienes suficientes créditos para generar una nueva cotización.',
      buyMore: 'Por favor compra más créditos para continuar usando el servicio.',
      confirm: 'Confirmar y Generar',
      buy: 'Comprar Créditos',
      cancel: 'Cancelar',
      processing: 'Procesando...'
    },
    limitModal: {
      title: 'Límite de Créditos Alcanzado',
      message: 'Has agotado tus créditos para hacer cotizaciones. Para continuar usando el sistema, necesitas comprar más créditos.',
      whatToDo: '¿Qué puedes hacer?',
      buyTokens: 'Compra uno de nuestros paquetes de créditos para continuar haciendo cotizaciones y acceder a todas las funcionalidades del sistema.',
      close: 'Cerrar'
    },
    purchase: {
      title: 'Comprar Paquetes de Créditos',
      subtitle: 'Selecciona el paquete de créditos que deseas comprar para hacer más cotizaciones.',
      mostPopular: 'Más popular',
      tokens: 'créditos',
      continue: 'Continuar al Pago',
      preparingPayment: 'Preparando pago...',
      errorPackageNotFound: 'Paquete de créditos no encontrado',
      errorPaymentIntent: 'No se recibió client secret del servidor',
      successTitle: '¡Compra Exitosa!',
      successMessage: 'Los créditos han sido añadidos a tu cuenta correctamente.'
    },
    checkout: {
      summary: 'Resumen de compra',
      package: 'Paquete:',
      tokens: 'Créditos:',
      price: 'Precio:',
      paymentInfo: 'Información de pago',
      billingAddress: 'Dirección de facturación',
      payNow: 'Pagar Ahora',
      processing: 'Procesando...',
      paymentSucceeded: '¡Pago completado exitosamente!',
      paymentProcessing: 'Tu pago está siendo procesado.',
      requiresPaymentMethod: 'Por favor proporciona un método de pago.',
      paymentError: 'Algo salió mal.',
      processingError: 'Error al procesar el pago. Por favor intenta de nuevo.',
      genericError: 'Ocurrió un error con tu pago',
      unexpectedError: 'Ocurrió un error inesperado'
    },
    transactionHistory: {
      title: 'Historial de Transacciones',
      noTransactions: 'No hay transacciones de créditos registradas',
      loading: 'Cargando historial...',
      usedQuotationsSectionTitle: 'Cotizaciones Usadas',
      purchasedCreditsSectionTitle: 'Créditos Comprados/Obtenidos',
      tokensAmount: 'Créditos',
      description: 'Descripción',
      date: 'Fecha',
      type: 'Tipo',
      filterAll: 'Todas las Transacciones',
      filterUsed: 'Cotizaciones Usadas',
      filterAcquired: 'Comprados/Obtenidos'
    },
    packages: {
      test_1: {
        name: 'Test Plan',
        description: 'Plan de prueba con 1 crédito de cotización'
      },
      basic_10: {
        name: 'Basic Plan',
        description: 'Plan Básico con 10 créditos para cotizaciones'
      },
      pro_20: {
        name: 'Pro Plan',
        description: 'Plan Pro con 20 créditos de cotización'
      },
      premium_50: {
        name: 'Premium Plan',
        description: 'Plan Premium con 50 créditos de cotización'
      }
    }
  },
  
  // Vehicle types - Using normalized keys for consistent lookup
  vehicles: {
    camionetadecargasencilla: "Camioneta de Carga Sencilla",
    camionetadecargacondoblerodado: "Camioneta de Carga con Doble Rodado",
    rabon: "Rabón",
    torton: "Torton",
    unidadensencilloconunremolquede2ejes: "Unidad en sencillo con un Remolque de 2 ejes",
    unidadensencilloconunremolquede3ejes: "Unidad en sencillo con un Remolque de 3 ejes",
    unidadenfullcon6ejesentotal: "Unidad en Full con 6 ejes en total",
    unidadenfullcon7ejesentotal: "Unidad en Full con 7 ejes en total",
    unidadenfullcon8ejesentotal: "Unidad en Full con 8 ejes en total",
    unidadenfullcon9ejesentotal: "Unidad en Full con 9 ejes en total"
  },
  
  // Trailer types - Using normalized keys for consistent lookup
  trailers: {
    cajaseca: "Caja Seca",
    cajarefrigerada: "Caja Refrigerada",
    plataforma: "Plataforma",
    portacontenedor: "Porta Contenedor",
    jaulagranelera: "Jaula Granelera",
    tolvagranelera: "Tolva Granelera",
    tolvapresurizada: "Tolva Presurizada",
    tanquedeliquidos: "Tanque de Líquidos",
    lowboy: "LowBoy o Cama Baja"
  },
  
  // Cargo types
  cargo: {
    mercanciageneral: "Mercancía General",
    alimentosperecederos: "Alimentos Perecederos",
    alimentosnopereceros: "Alimentos No Perecederos",
    materialesdecostruccion: "Materiales de Construcción",
    productosagricolas: "Productos Agrícolas",
    mobiliario: "Mobiliario",
    ropaytextiles: "Ropa y Textiles",
    productoselectronicos: "Productos Electrónicos",
    partesautomotrices: "Partes Automotrices",
    electrodomesticos: "Electrodomésticos",
    aceroymetales: "Acero y Metales",
    productosquimicos: "Productos Químicos",
    materialespeligrosos: "Materiales Peligrosos",
    productosfrágiles: "Productos Frágiles",
    mercanciadealotvalor: "Mercancía de Alto Valor",
    maquinaria: "Maquinaria",
    ganado: "Ganado",
    productosfarmaceuticos: "Productos Farmacéuticos",
    productosdemaderas: "Productos de Madera",
    otros: "Otros"
  },
  
  // Admin panel
  admin: {
    title: 'Panel de Administrador',
    usersManagement: 'Gestión de Usuarios',
    total: 'Total:',
    users: 'usuarios',
    search: 'Buscar usuarios...',
    refresh: 'Actualizar',
    usersTab: 'Usuarios',
    reportsTab: 'Reportes Globales',
    table: {
      name: 'Nombre',
      email: 'Email',
      tokens: 'Créditos',
      status: 'Estado',
      actions: 'Acciones'
    },
    status: {
      admin: 'Admin',
      noTokens: 'Sin tokens',
      lowTokens: 'Tokens bajos',
      active: 'Activo',
      administrator: 'Administrador',
      user: 'Usuario',
      unlimited: 'Ilimitados'
    },
    addTokens: 'Añadir tokens',
    addTokensForm: {
      title: 'Añadir Tokens',
      amount: 'Cantidad de Créditos',
      description: 'Descripción',
      addTokens: 'Añadir Créditos',
      addCredits: 'Añadir Créditos',
      processing: 'Procesando...',
      cancel: 'Cancelar',
      success: 'Se han añadido {{count}} tokens correctamente',
      error: 'No se pudieron añadir los tokens. Inténtalo nuevamente.',
      defaultDescription: 'Tokens asignados por administrador'
    },
    userDetail: 'Detalle de Usuario',
    transactionHistory: 'Historial de Transacciones',
    noTransactions: 'No hay transacciones registradas para este usuario',
    loadingTransactions: 'Cargando transacciones...',
    noUsersFound: 'No se encontraron usuarios',
    loadingUsers: 'Cargando usuarios...',
    errorLoading: 'Error al cargar información de usuarios',
    errorUpdating: 'Error al actualizar usuarios',
    accessDenied: {
      title: 'Acceso Denegado',
      message: 'No tienes permisos para acceder al panel de administración.'
    },
    transactionTable: {
      date: 'Fecha',
      type: 'Tipo',
      amount: 'Cantidad',
      description: 'Descripción'
    },
    transactionTypes: {
      used: 'Usado',
      purchased: 'Comprado',
      initial: 'Inicial',
      added: 'Añadido'
    },
    reports: {
      title: 'Reportes Globales',
      errorLoading: 'Error al cargar el reporte. Por favor, intenta nuevamente.',
      dateRanges: {
        last7Days: 'Últimos 7 días',
        last30Days: 'Últimos 30 días',
        last90Days: 'Últimos 90 días',
        allTime: 'Todo el tiempo'
      },
      summary: {
        totalQuotations: 'Total Cotizaciones',
        uniqueUsers: 'Usuarios Únicos',
        totalDistance: 'Distancia Total',
        averageCost: 'Costo Promedio'
      },
      countryDestinations: {
        title: 'Cotizaciones por País de Destino',
        noData: 'No hay datos de destinos para el período seleccionado',
        tableHeaders: {
          country: 'País',
          quotations: 'Cotizaciones',
          percentage: 'Porcentaje',
          cities: 'Ciudades'
        },
        showCities: 'Ver {{count}} ciudades',
        hideCities: 'Ocultar'
      },
      topRoutes: {
        title: 'Rutas Más Populares',
        noData: 'No hay datos de rutas para el período seleccionado',
        tableHeaders: {
          origin: 'Origen',
          destination: 'Destino',
          quotations: 'Cotizaciones',
          avgDistance: 'Distancia Prom.',
          avgCost: 'Costo Prom.'
        }
      },
      vehicleTypes: {
        title: 'Tipos de Vehículo',
        noData: 'No hay datos de vehículos'
      },
      cargoTypes: {
        title: 'Tipos de Carga',
        noData: 'No hay datos de tipos de carga'
      },
      export: {
        button: 'Exportar CSV',
        filename: 'reporte-global'
      },
      csv: {
        title: 'Reporte Global de Cotizaciones',
        summary: 'RESUMEN',
        totalQuotations: 'Total de Cotizaciones',
        uniqueUsers: 'Usuarios Únicos',
        totalDistance: 'Distancia Total (km)',
        averageCost: 'Costo Promedio',
        startDate: 'Fecha Inicio',
        endDate: 'Fecha Fin',
        countryDestinations: 'DESTINOS POR PAÍS',
        countryHeaders: 'País,Código,Cotizaciones,Porcentaje',
        topRoutes: 'RUTAS MÁS POPULARES',
        routeHeaders: 'Origen,Destino,Cotizaciones,Distancia Promedio (km),Costo Promedio',
        vehicleTypes: 'TIPOS DE VEHÍCULO',
        vehicleHeaders: 'Tipo de Vehículo,Cotizaciones,Porcentaje'
      }
    }
  },
  
  // Session timeout
  sessionTimeout: {
    warningMessage: "Tu sesión se cerrará automáticamente en 3 minutos por inactividad.",
    closedMessage: "Tu sesión ha sido cerrada por inactividad."
  },
  
  // PDF generation
  pdf: {
    title: 'Sistema de Cotización de Transporte de Carga Pesada',
    routeInfo: 'Información de la Ruta',
    origin: 'Origen',
    destination: 'Destino',
    additionalDestination: 'Destino Adicional',
    additionalDestinations: 'Destinos Adicionales',
    distance: 'Distancia (solo ida)',
    totalDistance: 'Distancia total (ida y vuelta)',
    equipmentConfig: 'Configuración del Equipo',
    unitType: 'Tipo de Unidad',
    trailerType: 'Tipo de Remolque',
    cargoType: 'Tipo de Mercancía',
    riskFactor: 'Factor de Riesgo',
    costInfo: 'Información de Costos',
    disclaimer: 'Nota: Los costos de combustible y desgaste de llantas se calculan considerando distancia de ida y vuelta.',
    driverSalaryNote: 'El salario del conductor se calcula con base en la distancia de solo ida.',
    tollNote: 'Los costos de casetas incluyen solo el viaje de ida.',
    currencyNote: 'Todos los montos están expresados en',
    validityNote: 'Esta cotización tiene validez de 15 días a partir de la fecha de emisión.',
    page: 'Página',
    of: 'de',
    detailedCostBreakdown: 'Desglose Detallado de Costos',
    route: 'Ruta:',
    equipment: 'Equipo:',
    concept: 'Concepto',
    amount: 'Importe',
    tollDetails: 'Detalles de Casetas',
    lastUpdated: 'Última actualización:',
    tollTable: {
      tollbooth: 'Caseta',
      operator: 'Operador',
      distance: 'Distancia',
      cost: 'Costo',
      paymentMethods: 'Métodos de Pago'
    },
    tollTotal: 'Total de Costos de Casetas:',
    tollOneWayNote: 'Los costos mostrados incluyen solo ida.',
    securityRecommendations: 'Recomendaciones de Seguridad:',
    responsibilityNote: 'Nota: Las recomendaciones de seguridad proporcionadas son orientativas y no son exhaustivas.',
    regulationsNote: 'Se recomienda cumplir con todas las regulaciones aplicables para el transporte de este tipo de carga.',
    mapRoute: 'Ruta:',
    mapCantLoad: 'Error al cargar mapa de ruta',
    mapCantLoadDesc: 'No se pudo procesar la imagen del mapa para esta cotización.',
    date: 'Fecha',
    company: {
      name: 'Cotizatrin',
      address: 'Tallinn, Estonia',
      phone: '',
      email: 'info_cotizatrin@autotrin.com',
      website: 'www.cotizatrin.com'
    },
    securityInfo: {
      title: 'Información de Carga y Seguridad',
      description: 'Descripción del Riesgo:',
      recommendationsTitle: 'Recomendaciones de Seguridad:',
      responsibilityNote: 'Nota: Las recomendaciones de seguridad proporcionadas son orientativas y no son exhaustivas.',
      regulationsNote: 'Se recomienda cumplir con todas las regulaciones aplicables para el transporte de este tipo de carga.'
    },
    notes: {
      title: 'Notas Importantes',
      validity: 'Esta cotización tiene validez de 15 días a partir de la fecha de emisión.',
      termsReference: 'Para términos y condiciones completos, visita www.cotizatrin.com/terminos',
      disclaimer: 'Los precios están sujetos a cambios sin previo aviso según las condiciones del mercado.'
    },
    segments: {
      info: 'Información de Segmentos',
      multiSegmentRoute: 'Información de Ruta Multi-Segmento',
      description: 'Esta cotización incluye {{count}} segmentos de ruta con diferentes estados de carga.',
      segment: 'Segmento',
      loaded: 'Cargado',
      empty: 'Vacío'
    }
  },
  
  // Loading Overlay
  loadingOverlay: {
    message: 'Por favor espera unos momentos mientras calculamos todos los costos, incluyendo casetas e impuestos.'
  },
  
  // Terms, policies, etc.
  legal: {
    termsConditions: 'Términos y Condiciones',
    privacyPolicy: 'Aviso de Privacidad'
  },
  
  // Language switcher
  language: {
    switch: 'Cambiar idioma',
    es: 'Español',
    en: 'English',
    spanish: 'Español',
    english: 'Inglés',
    selectAppLanguage: 'Selecciona el idioma que prefieres para usar la aplicación',
    label: 'Idioma'
  },
  
  // Errors
  errors: {
    missingInfo: 'Falta información requerida',
    calculationFailed: 'Error al calcular cotización',
    saveFailed: 'Error al guardar cotización',
    routeNotFound: 'No se encontró ruta entre estos puntos',
    routeCalculationFailed: 'Error al calcular ruta',
    tollCalculationFailed: 'Error al calcular costos de casetas',
    unknownError: 'Error desconocido',
    emailRequired: 'El correo electrónico es requerido',
    emailNotFound: 'No existe una cuenta con este correo',
    resetPasswordFailed: 'Ocurrió un error al enviar el correo de restablecimiento',
    passwordRequirements: 'La contraseña debe tener al menos 8 caracteres, una letra mayúscula y un número',
    passwordsMismatch: 'Las contraseñas no coinciden',
    nameRequired: 'El nombre es requerido',
    cityRequired: 'La ciudad es requerida',
    postalCodeRequired: 'El código postal es requerido',
    phoneRequired: 'El número telefónico es requerido',
    authError: 'Ocurrió un error durante la autenticación',
    mapImageMissing: 'No hay imagen del mapa disponible para descargar',
    downloadFailed: 'Error al descargar imagen'
  },
  
  // Terms and Conditions translations
  terms: {
    title: 'Términos y Condiciones',
    introduction: {
      title: '1. Introducción',
      content: 'Bienvenido a Cotizatrin, una plataforma de cotización de transporte de mercancías pesadas. Al acceder y utilizar nuestro servicio, aceptas estar sujeto a los siguientes términos y condiciones. Por favor, lee estos términos cuidadosamente antes de usar nuestra plataforma.'
    },
    definitions: {
      title: '2. Definiciones',
      intro: 'En estos Términos y Condiciones',
      cotizatrin: '"Cotizatrin", "nosotros", "nos" o "nuestro" se refiere a la plataforma Cotizatrin.',
      user: '"Usuario", "tú" o "tu" se refiere a cualquier persona que accede o utiliza la plataforma Cotizatrin.',
      service: '"Servicio" se refiere a la plataforma de cotización de transporte de mercancías pesadas proporcionada por Cotizatrin.',
      quotation: '"Cotización" se refiere a la estimación de costos generada por nuestra plataforma.'
    },
    serviceUse: {
      title: '3. Uso del Servicio',
      intro: 'Al utilizar nuestro servicio, aceptas',
      item1: 'Proporcionar información precisa y completa al registrarte y usar la plataforma.',
      item2: 'Mantener la confidencialidad de tu contraseña y cuenta.',
      item3: 'Ser responsable de todas las actividades que ocurran bajo tu cuenta.',
      item4: 'No usar el servicio para propósitos ilegales o no autorizados.',
      item5: 'No intentar dañar, sobrecargar o perjudicar de ninguna manera el funcionamiento de la plataforma.'
    },
    quotations: {
      title: '4. Cotizaciones',
      content: 'Las cotizaciones generadas por nuestra plataforma son estimaciones basadas en la información proporcionada y nuestros algoritmos de cálculo. Estas cotizaciones:',
      item1: 'Son solo para fines informativos y no constituyen una oferta vinculante.',
      item2: 'Pueden variar dependiendo de factores externos como condiciones climáticas, precio del combustible, etc.',
      item3: 'Tienen una validez de 15 días a partir de la fecha de emisión, salvo que se indique lo contrario.',
      item4: 'No incluyen impuestos adicionales, tarifas de casetas, o cargos especiales que puedan aplicar.'
    },
    userAccounts: {
      title: '5. Cuentas de Usuario',
      content: 'Para usar ciertas características de nuestra plataforma, es necesario crear una cuenta de usuario. Al crear una cuenta, aceptas:',
      item1: 'Proporcionar información precisa, actual y completa.',
      item2: 'Actualizar tu información cuando sea necesario para mantenerla precisa y completa.',
      item3: 'Ser únicamente responsable de proteger la confidencialidad de tu contraseña.',
      item4: 'Notificarnos inmediatamente de cualquier uso no autorizado de tu cuenta.'
    },
    privacy: {
      title: '6. Privacidad',
      content: 'Respetamos tu privacidad y estamos comprometidos a proteger tus datos personales. Nuestra Política de Privacidad explica cómo recopilamos, usamos y protegemos la información que proporcionas. Al usar nuestro servicio, aceptas nuestras prácticas de privacidad.'
    },
    intellectualProperty: {
      title: '7. Propiedad Intelectual',
      content: 'Todos los derechos de propiedad intelectual relacionados con la plataforma Cotizatrin, incluyendo pero no limitado a software, diseños, logotipos, textos, gráficos y contenido, son propiedad de Cotizatrin o sus licenciantes. Está prohibida la reproducción, distribución, modificación o cualquier otro uso no autorizado de estos materiales.'
    },
    liability: {
      title: '8. Limitación de Responsabilidad',
      content: 'Cotizatrin proporciona la plataforma "tal como está" y "según disponibilidad", sin garantías de ningún tipo. No garantizamos que el servicio será ininterrumpido, seguro o libre de errores. En ningún caso Cotizatrin será responsable por daños indirectos, incidentales, especiales, consecuenciales o punitivos, incluidos la pérdida de beneficios, datos o uso.'
    },
    modifications: {
      title: '9. Modificaciones',
      content: 'Nos reservamos el derecho de modificar estos términos y condiciones en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación en la plataforma. Es tu responsabilidad revisar periódicamente estos términos para mantenerte informado de las actualizaciones.'
    },
    applicableLaw: {
      title: '10. Ley Aplicable',
      content: 'Estos términos y condiciones se regirán e interpretarán de acuerdo con las leyes de México, sin tener en cuenta sus disposiciones sobre conflictos de leyes. Cualquier disputa que surja en relación con estos términos estará sujeta a la jurisdicción exclusiva de los tribunales competentes de la Ciudad de México.'
    },
    contact: {
      title: '11. Contacto',
      content: 'Si tienes preguntas o inquietudes sobre estos términos y condiciones, por favor contáctanos en'
    },
    lastUpdate: 'Última actualización: 15 de mayo de 2025'
  },
  
  // Business and Local SEO Information
  business: {
    name: 'Cotizatrin',
    description: 'Plataforma especializada en cotización de transporte de mercancías pesadas con datos actualizados de peajes y rutas',
    address: 'Tallinn, Estonia',
    phone: '',
    email: 'info_cotizatrin@autotrin.com',
    hours: {
      title: 'Horarios de Atención',
      weekdays: 'Lun - Vie: 8:00 AM - 6:00 PM',
      saturday: 'Sábado: 9:00 AM - 2:00 PM',
      sunday: 'Domingo: Cerrado'
    },
    services: {
      title: 'Nuestros Servicios',
      quotation: 'Cotización de Transporte de Mercancías Pesadas',
      tolls: 'Cálculo de Casetas en Tiempo Real',
      routes: 'Análisis de Rutas Optimizadas',
      security: 'Recomendaciones de Seguridad',
      reports: 'Reportes PDF Profesionales'
    },
    contact: {
      title: 'Información de Contacto',
      address: 'Dirección',
      phone: 'Teléfono',
      email: 'Correo Electrónico',
      viewOnMaps: 'Ver en Google Maps',
      ourLocation: 'Nuestra Ubicación',
      mapTitle: 'Ubicación de Cotizatrin'
    },
    googleBusiness: {
      title: 'Encuéntranos en',
      viewProfile: 'Ver perfil completo'
    }
  },
  
  // Privacy Policy translations
  privacy: {
    title: 'Aviso de Privacidad',
    introduction: {
      title: '1. Introducción',
      content: 'Este Aviso de Privacidad describe cómo Cotizatrin recopila, utiliza, almacena y protege la información personal que nos proporcionas a través de nuestra plataforma de cotización de transporte de mercancías pesadas. Estamos comprometidos a proteger tu privacidad y cumplir con todas las leyes y regulaciones aplicables sobre protección de datos personales.'
    },
    collectedInfo: {
      title: '2. Información que Recopilamos',
      intro: 'Podemos recopilar los siguientes tipos de información personal',
      item1: 'Nombre completo',
      item2: 'Dirección de correo electrónico',
      item3: 'Número de teléfono',
      item4: 'Ciudad y código postal',
      item5: 'Nombre de la empresa (opcional)',
      item6: 'Información de ubicación y rutas (origen y destino de cotizaciones)',
      item7: 'Información de vehículos y carga',
      item8: 'Historial de cotizaciones'
    },
    infoUse: {
      title: '3. Uso de tu Información',
      intro: 'Utilizamos la información recopilada para',
      item1: 'Crear y gestionar tu cuenta en nuestra plataforma',
      item2: 'Procesar y almacenar tus cotizaciones de transporte',
      item3: 'Calcular costos de transporte precisos según tus especificaciones',
      item4: 'Comunicarnos contigo sobre tu cuenta y cotizaciones',
      item5: 'Mejorar nuestros servicios y desarrollar nuevas funcionalidades',
      item6: 'Proporcionar servicio al cliente y soporte técnico',
      item7: 'Enviar información relevante sobre nuestros servicios (con tu consentimiento)',
      item8: 'Cumplir con nuestras obligaciones legales'
    },
    storageSecurity: {
      title: '4. Almacenamiento y Seguridad',
      content1: 'Tu información personal se almacena en servidores seguros y utilizamos medidas de seguridad técnicas, administrativas y físicas apropiadas para proteger tus datos contra acceso, uso o divulgación no autorizados. Nuestros sistemas están diseñados para mantener la integridad y confidencialidad de tu información.',
      content2: 'Conservamos tu información personal solo el tiempo necesario para los propósitos descritos en este aviso de privacidad o según lo requiera la ley.'
    },
    infoSharing: {
      title: '5. Compartir Información',
      content: 'No vendemos ni alquilamos tu información personal a terceros. Podemos compartir tu información en las siguientes circunstancias:',
      item1: 'Con proveedores de servicios que nos ayudan a operar nuestra plataforma',
      item2: 'Cuando sea requerido por ley o autoridades competentes',
      item3: 'Para proteger nuestros derechos, privacidad, seguridad o propiedad',
      item4: 'En caso de fusión, adquisición o venta de activos (con las salvaguardas apropiadas)'
    },
    cookies: {
      title: '6. Uso de Cookies y Tecnologías Similares',
      content: 'Utilizamos cookies y tecnologías similares para mejorar tu experiencia en nuestra plataforma, entender cómo la usas y personalizar nuestros servicios. Puedes gestionar tus preferencias de cookies a través de la configuración de tu navegador.'
    },
    userRights: {
      title: '7. Tus Derechos',
      intro: 'Tienes derecho a',
      item1: 'Acceder a la información personal que tenemos sobre ti',
      item2: 'Corregir datos inexactos o incompletos',
      item3: 'Solicitar la eliminación de tus datos personales',
      item4: 'Oponerte o limitar el procesamiento de tus datos',
      item5: 'Retirar tu consentimiento en cualquier momento',
      item6: 'Solicitar la portabilidad de tus datos',
      item7: 'Presentar una queja ante la autoridad de protección de datos',
      contact: 'Para ejercer cualquiera de estos derechos, por favor contáctanos en'
    },
    policyChanges: {
      title: '8. Cambios a este Aviso',
      content: 'Podemos actualizar este Aviso de Privacidad periódicamente para reflejar cambios en nuestras prácticas de información o requisitos legales. Publicaremos la versión actualizada en nuestra plataforma con la fecha de última actualización. Te recomendamos revisar este aviso regularmente.'
    },
    minors: {
      title: '9. Menores de Edad',
      content: 'Nuestros servicios no están dirigidos a menores de 18 años de edad y no recopilamos a sabiendas información personal de menores. Si descubrimos que hemos recopilado información personal de un menor, tomaremos medidas para eliminar dicha información lo antes posible.'
    },
    contact: {
      title: '10. Contacto',
      content: 'Si tienes preguntas o inquietudes sobre este Aviso de Privacidad o sobre el manejo de tus datos personales, contáctanos en'
    },
    lastUpdate: 'Última actualización: 15 de mayo de 2025'
  },

  // Form Guide translations
  formGuide: {
    title: 'Guía de Completado del Formulario para Cotización',
    returnToForm: 'Volver al Formulario',
    introduction: {
      title: 'Introducción',
      content: 'Esta guía te ayudará a completar correctamente el formulario de cotización para obtener el costo más preciso para tu transporte de carga. Sigue los pasos a continuación para una experiencia fluida.'
    },
    basicMode: {
      title: 'Modo Básico vs. Modo Avanzado',
      content: 'El formulario tiene dos modos de operación:',
      basic: 'Modo Básico: Incluye configuración de vehículo, precio de combustible y ubicaciones. Ideal para cotizaciones rápidas.',
      advanced: 'Modo Avanzado: Agrega tipo de carga, parámetros de costos personalizados y selección de moneda. Recomendado para cotizaciones más precisas y profesionales.',
      howToEnable: 'Para activar el Modo Avanzado, haz clic en el botón "Avanzado" en la barra de navegación superior.'
    },
    vehicleSelection: {
      title: 'Selección de Vehículo',
      description: 'La configuración del vehículo es fundamental para obtener una cotización precisa:',
      vehicleTypes: 'Tipos de Vehículos Disponibles:',
      pickupTruck: 'Camionetas de Carga: Para cargas ligeras (1.5-3.5 toneladas)',
      mediumTrucks: 'Rabón y Torton: Para cargas medianas (10-15 toneladas)',
      tractorTrailers: 'Tractocamiones: Para cargas pesadas (25-35 toneladas)',
      fullUnits: 'Unidades Full: Para cargas muy pesadas y de alto volumen (40+ toneladas)',
      trailerSelection: 'Selección de Remolque:',
      trailerNote: 'Solo aparece para vehículos que requieren remolque (tractocamiones y unidades full)',
      visualSelection: 'Usa los íconos visuales para identificar fácilmente el tipo de vehículo y remolque que necesitas.'
    },
    fuelPrice: {
      title: 'Precio del Combustible',
      description: 'Esta sección es siempre visible y fundamental para el cálculo:',
      currentPrice: 'El sistema muestra un precio predeterminado actualizado',
      customPrice: 'Puedes ajustar el precio si tienes información más precisa de tu proveedor',
      impactNote: 'El precio del combustible afecta directamente el costo total de transporte'
    },
    locationSelection: {
      title: 'Selección de Ubicaciones',
      originDestination: 'Origen y Destino',
      enterLocations: 'Ingresa las ubicaciones exactas para el origen y destino de tu carga:',
      option1: 'Escribe la dirección completa',
      option2: 'Selecciona de las sugerencias de autocompletado',
      option3: 'Localiza el punto en el mapa interactivo',
      addressHelper: 'IMPORTANTE: Incluye la dirección más completa posible (calle y número, colonia, ciudad, estado, código postal) para evitar ubicaciones incorrectas',
      mapInteraction: 'Interacción con el Mapa:',
      dragMarkers: 'Puedes arrastrar los marcadores para ajustar la posición exacta',
      mapCalculation: 'El mapa calculará automáticamente la ruta entre los puntos seleccionados',
      clearMap: 'Usa el botón "Limpiar Mapa" para empezar de nuevo',
      routeValidation: 'Verifica que la ruta mostrada en el mapa sea correcta antes de generar la cotización'
    },
    intermediateStops: {
      title: 'Destinos Adicionales (Opcional)',
      howToEnable: 'Cómo Habilitar:',
      enableStep: 'Marca la casilla "Habilitar Destinos Adicionales" para activar esta funcionalidad',
      description: 'Una vez habilitado, puedes agregar hasta 5 destinos adicionales para rutas complejas:',
      addingDestinations: 'Agregar Destinos:',
      step1: 'Haz clic en "Agregar destino" para añadir una nueva ubicación',
      step2: 'Ingresa la dirección completa del destino',
      step3: 'Configura el estado de carga para cada segmento (cargado/vacío)',
      loadStatus: 'Estado de Carga:',
      loadedDesc: 'Cargado: El vehículo transporta mercancía en ese segmento',
      emptyDesc: 'Vacío: El vehículo viaja sin carga (menor consumo de combustible)',
      routeSequence: 'Secuencia de Ruta:',
      routeOrder: 'La ruta se calcula en orden: Origen → Destino Principal → Destino Adicional 1 → Destino Adicional 2, etc.',
      optimization: 'El sistema NO reordena automáticamente para optimizar la ruta',
      costCalculation: 'Cálculo de Costos:',
      segmentCosts: 'Cada segmento se calcula individualmente según su estado de carga',
      limitations: 'Consideraciones Importantes:',
      tollAccuracy: 'Muchos destinos pueden afectar la precisión de los cálculos de casetas',
      routeComplexity: 'Las rutas muy complejas pueden tardar más en procesarse'
    },
    advancedMode: {
      title: 'Características del Modo Avanzado',
      description: 'El Modo Avanzado agrega opciones profesionales para cotizaciones más precisas:',
      howToEnable: 'Cómo Activar:',
      enableButton: 'Haz clic en el botón "Avanzado" en la barra de navegación superior',
      sections: 'Secciones Adicionales:',
      cargoType: 'Tipo de Mercancía:',
      cargoTypeDesc: 'Selecciona el tipo específico de mercancía que transportarás. Esto afecta el factor de riesgo y las recomendaciones de seguridad.',
      riskFactors: 'Factores de Riesgo:',
      riskGeneral: 'Mercancía General: Factor estándar (1.0x)',
      riskPerishable: 'Alimentos Perecederos: Factor alto (1.3x)',
      riskElectronics: 'Productos Electrónicos: Factor muy alto (1.4x)',
      riskHazardous: 'Materiales Peligrosos: Factor extremo (1.8x)',
      costParameters: 'Parámetros de Costos:',
      profitMargin: 'Margen de Utilidad: Define el porcentaje de ganancia sobre el costo base',
      vatTax: 'IVA/Impuesto: Porcentaje de impuesto aplicado a los costos de casetas',
      currencySelection: 'Selección de Moneda:',
      currencyDesc: 'Elige la moneda en la que quieres ver todos los resultados (MXN, USD, EUR, etc.)',
      conversionNote: 'Todos los costos se convertirán automáticamente a la moneda seleccionada'
    },
    generatingQuotation: {
      title: 'Generar Cotización',
      requirements: 'Requisitos para Generar:',
      reqVehicle: 'Seleccionar tipo de vehículo (y remolque si aplica)',
      reqLocations: 'Ingresar origen y destino válidos',
      reqRoute: 'Calcular la ruta en el mapa',
      reqTokens: 'Tener al menos 1 crédito de cotización disponible',
      reviewGenerate: 'Proceso de Generación:',
      step1: 'Revisa que la información sea correcta',
      step2: 'Haz clic en el botón verde "Generar Cotización"',
      step3: 'Confirma que quieres usar 1 crédito para este cálculo',
      step4: 'Espera mientras se procesa la información y se calculan las casetas',
      automaticSave: 'Guardado Automático:',
      autoSaveDesc: 'La cotización se guarda automáticamente en tu historial después de la generación',
      resultIncludes: 'La cotización generada incluirá:',
      detailedBreakdown: 'Desglose detallado de costos en la moneda seleccionada',
      tollInfo: 'Información de casetas con costos convertidos',
      securityRecommendations: 'Recomendaciones de seguridad basadas en el tipo de carga (modo avanzado)',
      routeMap: 'Mapa de la ruta',
      afterGenerate: 'Después de Generar',
      afterGenerateDesc: 'Una vez generada la cotización, puedes:',
      newQuotation: 'Crear una "Nueva Cotización" con el botón azul',
      changeCurrency: 'Cambiar la moneda para ver costos en diferentes denominaciones',
      downloadPDF: 'Descargar la cotización en formato PDF (se generará en la moneda seleccionada)',
      downloadMap: 'Descargar solo la imagen del mapa de la ruta',
      viewHistory: 'Ver el historial de cotizaciones en la pestaña correspondiente',
      tokenNote: 'Cada cotización generada consume un token. Si necesitas crear múltiples variantes, considera adquirir un paquete de tokens adicional.'
    },
    tips: {
      title: 'Consejos para Mejores Resultados',
      tip1: 'Usa direcciones completas con código postal para mayor precisión',
      tip2: 'Verifica que la ruta en el mapa sea correcta antes de generar',
      tip3: 'El modo avanzado proporciona cotizaciones más profesionales y detalladas',
      tip4: 'Los estados de carga (cargado/vacío) afectan significativamente los costos de combustible',
      tip5: 'Guarda cotizaciones importantes descargando el PDF'
    },
    additionalHelp: {
      title: '¿Necesitas Ayuda Adicional?',
      content: 'Si tienes preguntas específicas sobre cómo completar alguna parte del formulario o necesitas asistencia personalizada, contacta a nuestro equipo de soporte:'
    }
  },
  
  // Map component translations
  mapComponent: {
    loading: 'Cargando Mapa...',
    errorLoading: 'Error al cargar Google Maps',
    calculateRoute: 'Calcular Ruta',
    calculating: 'Calculando...',
    routeNotFound: 'No se encontró ruta entre estos puntos',
    placesLoading: 'Cargando servicios de Google Maps...',
    locationSelected: 'Ubicación seleccionada exitosamente',
    instructions: 'Instrucciones del Mapa',
    instructionsMap: 'Selecciona origen y destino, luego haz clic en "Calcular Ruta"',
    instructionsDragMarkers: 'O haz clic en el mapa para colocar marcadores y arrástralos para ajustar posición',
    clearMap: 'Limpiar Mapa',
    calculateRouteNow: 'Calcular Ruta Ahora',
    locationConfirmed: '✓ Ubicación establecida',
    routeSequence: 'Secuencia de ruta: Origen → Destino Principal → Destinos Adicionales',
    destinationMarker: 'Destino principal (B)',
    additionalMarker: 'Destino adicional',
    waypointMarker: 'Parada intermedia',
    originMarker: 'Origen (A)'
  },
  
  // Location selection section
  locationSelection: {
    title: 'Selección de Ubicaciones',
    originCountryLabel: 'País/Región del Origen',
    destinationCountryLabel: 'País/Región del Destino',
    originCountryHelper: 'País donde se encuentra la ubicación de origen',
    destinationCountryHelper: 'País donde se encuentra la ubicación de destino',
    instructions: 'Ingresa ubicaciones exactas para origen y destino',
    option1: 'Ingresa la dirección completa en el campo',
    option2: 'Selecciona de las sugerencias de autocompletado',
    option3: 'Haz clic directamente en el mapa para colocar marcadores',
    tip: 'Ubicaciones precisas resultan en cotizaciones más exactas',
    checkMap: 'Verifica que ambos marcadores aparezcan correctamente en el mapa',
    noRoute: 'Si es necesario, ajusta las posiciones de los marcadores arrastrándolos',
    clearMap: 'Usa "Limpiar Mapa" para empezar de nuevo',
    routeOrder: 'La ruta se calculará en este orden:',
    routeSequence: '1. Origen → 2. Destino Principal → 3. Destinos Adicionales',
    locationInputHelper: 'Para mayor precisión, incluye: calle y número, colonia/barrio, ciudad, estado y código postal.',
    countrySelection: 'Selección de País',
    countrySelectionHelper: 'Selecciona el país donde se encuentran las direcciones para mejorar la precisión',
    countrySelectionTip: 'Seleccionar el país correcto previene errores de ubicación y mejora la precisión de las direcciones',
    originCountry: 'País del origen',
    destinationCountry: 'País del destino',
    internationalRoute: 'Ruta Internacional',
    internationalRouteHelper: 'Selecciona países diferentes para origen y destino si esta es una ruta internacional',
    additionalDestinationsCountry: 'País de destinos adicionales',
    additionalDestinationsCountryHelper: 'País donde se encuentran los destinos adicionales para mejorar la precisión de búsqueda'
  },
  
  // Quotation section with missing translations
  quotation: {
    additionalDestinationsCountry: 'País de destinos adicionales',
    additionalDestinationsCountryHelper: 'País donde se encuentran los destinos adicionales para mejorar la precisión de búsqueda',
    internationalRoute: 'Ruta Internacional',
    internationalRouteHelper: 'Selecciona países diferentes para origen y destino si esta es una ruta internacional'
  },

  // PWA Installation Prompt
  pwa: {
    install: {
      title: 'Instala Cotizatrin',
      description: 'Accede más rápido y obtén una mejor experiencia',
      benefit1: 'Acceso directo desde tu pantalla de inicio',
      benefit3: 'Recibe notificaciones instantáneas',
      installButton: 'Instalar',
      notNow: 'Ahora no',
      installing: 'Instalando...'
    }
  }
};